import React, {Component} from "react";
import TodayTrade from "./TodayTradeView";
import {VentanillaService} from "../../../service/ventanilla/VentanillaService";

export default class TodayTradeContainer extends Component {
    constructor(props) {
        super(props);

        this.ventanillaService = new VentanillaService();

        this.loading = this.loading.bind(this);
        this.getTodayTrade = this.getTodayTrade.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.exportXLS = this.exportXLS.bind(this);
        this.exportPDF = this.exportPDF.bind(this);

        this.state = {
            isLoading: true,
            returnPath: this.props.location.state.returnPath,
            todayTrade: this.getTodayTrade(),
            options: [],
            exportOptions: [
                {label: "Excel", action: this.exportXLS},
                {label: "PDF", action: this.exportPDF},
            ],
        };
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    getTodayTrade() {
        this.loading();
        return this.ventanillaService.getAverageTrade().then(
            todayTrade =>
                this.setState({
                    todayTrade: todayTrade,
                    isLoading: false,
                }))
    }

    exportXLS() {
        this.loading();
        this.ventanillaService.exportAverageTrade('XLS').then(response => {
                this.setState({
                    isLoading: false
                });
            }
        );
    }

    exportPDF() {
        this.loading();
        this.ventanillaService.exportAverageTrade('PDF').then(response => {
                this.setState({
                    isLoading: false
                });
            }
        );
    }

    render() {
        return <TodayTrade
            isLoading={this.state.isLoading}
            handleReturnButton={this.handleReturnButton}
            todayTrade={this.state.todayTrade}
            getTodayTrade={this.getTodayTrade}
            exportOptions={this.state.exportOptions}
        />
    }
};
